import { Button, Input, Radio } from "antd";
import styled from "styled-components/macro";
import { COLORS, SIZES, WEIGHT } from "../../../../layout/theme";

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 32px;
	font-weight: 700;
	line-height: 1.1;
	color: #0f172a;

	@media only screen and (max-width: 768px) {
		font-size: 30px;
	}
`;

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 10px 24px 32px;

	@media only screen and (max-width: 768px) {
		padding: 8px 12px 24px;
	}
`;

export const FilterCard = styled.div`
	width: 100%;
	background: ${COLORS.White};
	border-radius: 20px;
	padding: 26px 28px;
	box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
`;

export const FilterContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 16px;
	align-items: center;

	.ant-picker,
	.ant-select-selector,
	.ant-input-affix-wrapper,
	.ant-input {
		height: 40px !important;
		border-radius: 14px !important;
		border: 1px solid #cbd5e1 !important;
		box-shadow: none !important;
		font-size: 16px !important;
	}

	.ant-picker,
	.ant-input-affix-wrapper,
	.ant-input {
		padding: 0 16px !important;
	}

	.ant-select-selector {
		padding: 0 16px !important;
		display: flex !important;
		align-items: center !important;
	}

	.ant-select-selection-placeholder,
	.ant-select-selection-item,
	.ant-picker-input input,
	.ant-input {
		color: #334155 !important;
		font-size: 16px !important;
	}

	.ant-picker:hover,
	.ant-picker-focused,
	.ant-select-focused .ant-select-selector,
	.ant-select:hover .ant-select-selector,
	.ant-input-affix-wrapper:hover,
	.ant-input-affix-wrapper-focused,
	.ant-input:hover,
	.ant-input:focus {
		border-color: #4f46e5 !important;
		box-shadow: 0 0 0 2px rgba(79, 70, 229, 0.08) !important;
	}

	.ant-picker-range {
		min-width: 260px;
	}

	@media only screen and (max-width: 1200px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			flex: 1 1 220px;
			min-width: 220px;
		}
	}

	@media only screen and (max-width: 768px) {
		.ant-picker-range,
		.ant-select,
		.ant-input-affix-wrapper {
			width: 100%;
			min-width: 100%;
		}
	}
`;

export const FilterSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const FilterActions = styled.div`
	display: flex;
	gap: 12px;
	align-items: center;
	margin-left: auto;

	@media only screen and (max-width: 1200px) {
		margin-left: 0;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const PrimaryButton = styled(Button)`
	height: 40px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: linear-gradient(90deg, #4f46e5 0%, #4f46e5 100%);
	color: ${COLORS.White};
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #4338ca 100%) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const SecondaryButton = styled(Button)`
	height: 40px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: #e5e7eb;
	color: #1f2937;
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);

	&:hover,
	&:focus,
	&:active {
		background: #d1d5db !important;
		color: #111827 !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const TerciaryButton = styled(Button)`
	height: 40px;
	padding: 0 28px;
	border-radius: 14px;
	border: none;
	background: ${COLORS.White};
	color: #1f2937;
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
	margin-right: 5px;

	&:hover,
	&:focus,
	&:active {
		background: #d1d5db !important;
		color: #111827 !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const TableWrapper = styled.div`
	width: 100%;
	border-radius: 20px;
	overflow: hidden;
`;

export const Header = styled.div`
	margin-bottom: 20px;
	display: flex;
	gap: 10px;
`;

export const Inner = styled.div`
	padding: 30px 100px;
	background-color: ${COLORS.LightGrey};
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	z-index: 3;
`;

export const TotalsCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 2rem;
	gap: 30px;
	width: 40%;
	height: 50px;
	background-color: ${COLORS.White};
	border-radius: 10px;
`;

export const CompaginationDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-top: 18px;

	.ant-btn {
		width: 34px;
		height: 34px;
		border-radius: 999px;
		border: 1px solid #d1d5db;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: none;
	}
`;

export const AntdInput = styled(Input)`
	.ant-input-group .ant-input {
		height: 30px;
		border: 1px solid #cbd5e1;
		border-radius: 12px 0 0 12px;
		background-color: ${COLORS.White};
		text-align: center;
		padding: 5px 8px;
		font-weight: 600;
		color: #334155;
	}

	.ant-input-group .ant-input:hover,
	.ant-input-group .ant-input:focus {
		border: 1px solid #4f46e5;
		box-shadow: none;
	}

	.ant-input-group-addon {
		border: 1px solid #cbd5e1;
		border-left: 0;
		background-color: ${COLORS.White};
		padding: 0 10px;
		border-radius: 0 12px 12px 0;
		color: #64748b;
		font-weight: 600;
	}
`;

export const CalendarButton = styled(Button)`
	margin-top: 20px;
	border-radius: 5px;
`;

export const RadioOptions = styled.div`
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const AntdRadioButton = styled(Radio.Button)`
	border: none;
	font-weight: ${WEIGHT.Bold};
`;

export const ButtonOffer = styled.button`
	cursor: pointer;

	&:hover {
		color: ${COLORS.Primary};
		border: 2px solid ${COLORS.White};
		background-color: ${COLORS.White};
		box-shadow: 0 1px 1px #bfbfbf;
	}
	color: ${COLORS.White};
	font-size: ${SIZES.level7};
	font-weight: ${WEIGHT.Black};
	background-color: ${COLORS.Primary};
	margin: 1em;
	padding: 0.2em 1em;
	border: 2px solid ${COLORS.Primary};
	border-radius: 20px;
	box-shadow: 0 5px 5px #bfbfbf;
	margin-right: 60px;
`;
